// App version — set VITE_APP_VERSION env var at build time, fall back to local constant
export const VERSION = import.meta.env.VITE_APP_VERSION ?? 'v1.1.0';